export enum TorqueUnit {
    Nm,
    MMn
}
